var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%","display":"flex","justify-content":"center","align-items":"center"}},[_c('img',{staticStyle:{"width":"80vw","object-fit":"contain"},attrs:{"src":require("../../assets/noMobile.png")}})])
}]

export { render, staticRenderFns }